<template>
  <span
    class="shared-step-editor-form-field"
    :class="{
      'shared-step-editor-form-field--focused': focused,
    }"
  >
    <label
      v-if="label"
      :for="fieldId"
      class="shared-step-editor-form-field__label"
      :class="{'shared-step-editor-form-field__label--error': !!error}"
    >
      {{ label }}
    </label>

    <span
      class="shared-step-editor-form-field__field"
      :class="{'shared-step-editor-form-field__field--error': !!error}"
    >
      <slot />
    </span>

    <span v-show="error || hint" class="shared-step-editor-form-field__footer">
      <span
        class="shared-step-editor-form-field__error"
        :class="{
          ['shared-step-editor-form-field__error--' + errorPosition]: !!errorPosition,
        }"
      >
        {{ error }}
      </span>

      <span
        class="shared-step-editor-form-field__hint"
        :class="{'shared-step-editor-form-field__hint--error': !!error}"
      >
        {{ hint }}
      </span>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    error: String,
    errorPosition: {
      type: String,
      default: 'absolute',
    },
    focused: Boolean,
    fieldId: String,
    hint: String,
    height: {
      type: Number,
      default: 52,
    },
    label: String,
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../sass/web/_variables.scss';

.shared-step-editor-form-field {
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 0;

  &__field {
    box-sizing: border-box;
    caret-color: $black-color;
    color: $black-color;
    display: inline-flex;
    align-items: center;
    font-size: 14px;
    height: 100%;

    &::before {
      border-radius: 4px;
      box-shadow: 0 0 0 1px #d9dce4 inset;
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
    }

    &:focus-within {
      &::before {
        box-shadow: 0 0 0 2px $half-baked-color inset;
      }
    }

    &--error {
      &::before {
        box-shadow: 0 0 0 2px $red-color inset !important;
      }
    }
  }

  &--focused &__field::before {
    box-shadow: 0 0 0 2px $half-baked-color inset;
  }

  &__label {
    background-color: $white-color;
    font-size: 11px;
    height: 11px;
    line-height: 11px;
    padding: 0 3px;
    position: absolute;
    top: -9px;
    left: 8px;
    z-index: 1;
    font-weight: 600;
    color: $color-regent-grey;

    &--error {
      color: $red-color;
    }
  }

  &--focused &__label,
  &:focus-within &__label {
    color: $half-baked-color;
  }

  &__footer {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 0 8px;
    height: 0;
  }

  &__error {
    color: $red-color;
    font-size: 12px;
    line-height: 18px;
    padding: 8px 2px;

    &--absolute {
      position: absolute;
      bottom: -32px;
    }
  }

  &__hint {
    color: $color-gunsmoke;
    font-size: 12px;
    line-height: 18px;
    padding: 8px 2px;

    &--error {
      color: $red-color;
    }
  }
}
</style>
